export default __webpack_public_path__ + "static/media/4_1.0fc27555.png";